import * as types from './actionTypes';
import { getPatternColors } from '../reducers/patterns';
import { color2string } from '../helper/ColorUtils';

export const resetPatternColors = (patternid, colors) => ({
    type: types.COLORS_RESETTED,
    patternid,
    colors,
});

/**
 * Action creator for changes of a single color value through the swatches.
 *
 * @param color
 * @returns {function(*, *)}
 */
export const singleColorChanged = color => (dispatch, getState) => {
    const { patternid, sewpatId } = getState().location.payload;
    color = color.hsl;
    dispatch({
        type: types.COLOR_CHANGED,
        color,
        patternid,
    });

    const state = getState();
        // @ToDo combine the next two functions.
    const colors = getPatternColors(state, patternid);
    const colorString = color2string(colors);
    const query = { colors: colorString };
    dispatch({
        type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
        payload: { patternid, sewpatId },
        query,
        search: query,
    });
};
/**
 *
 * @param color
 * @returns {function(*, *)}
 */
export const colorpickerColorChanged = color => {
    color = color.hsl;
    return (dispatch, getState) => {
        const patternid = getState().location.payload.patternid;
        dispatch({
            type: types.COLOR_CHANGED,
            color,
            patternid,
        });
    };
};

/**
 * Action creator for changes through the slider.
 *
 * @param value
 * @param sliderType
 * @returns {function(*, *)}
 */
export const sliderColorChanged = (value, sliderType) => (dispatch, getState) => {
    const patternid = getState().location.payload.patternid;

    if (sliderType && sliderType === 'hue') {
        dispatch({
            type: types.SLIDER_HUE_CHANGED,
            color: value,
            patternid,
        });
    }

    if (sliderType && sliderType === 'saturation') {
        dispatch({
            type: types.SLIDER_SATURATION_CHANGED,
            color: value,
            patternid,
        });
    }

    if (sliderType && sliderType === 'lightness') {
        dispatch({
            type: types.SLIDER_LIGHTNESS_CHANGED,
            color: value,
            patternid,
        });
    }

    return Promise.resolve();
};



// WEBPACK FOOTER //
// ./src/actions/recoloring.js